import CourseMapImages from './container';

export default CourseMapImages;



// WEBPACK FOOTER //
// ./app/src/components/EventDetail/CourseMapImages/index.js